import client from '../httpClient';

const settingGroupStoreSearchApi = (areaCode, params) => {
  return client.get(`/store-groups/settings/search/${areaCode}`, JSON.stringify(params));
};

export default settingGroupStoreSearchApi;
